// @flow

import styled from 'styled-components'

const Review = styled.div`
  a:hover {
    text-decoration: underline;
  }
  margin-left: ${Math.ceil(24 / -2)};
  margin-right: ${Math.floor(24 / -2)};
  &:before,
  &:after {
    content: '';
    display: table;
  }
  &:after {
    clear: both;
  }
`

export default Review



// WEBPACK FOOTER //
// ./src/components/space/Review.jsx